import React from "react";

export default function Videos() {
  return <div>Videos</div>;
}
